















































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import {SigfoxApiCredentials} from '@/types';
import ConnectivityService from '@/services/connectivity.service';

@Component({
  components: {
  },
})
export default class SigfoxCredentials extends Vue {
  private toggleForm: boolean = false;
  private hasPassword: boolean = false;
  private dialog: boolean = false;
  private valid: boolean = false;
  private showForm: boolean = false;
  private snackbar: boolean = false;

  private requiredRules: object = {};
  private newPassword: string = '';

  private credentials: SigfoxApiCredentials = {
    login: '',
    sigfox_group: '',
    default_contract_id: '',
  };

  private mounted() {
    this.initForm();
  }

  private async initForm() {
    this.newPassword = '';
    this.credentials = {} as SigfoxApiCredentials;

    const creds = await ConnectivityService.getSigfoxApiCredentials();

    if (creds) {
      this.hasPassword = true;
      this.credentials = {
        id: creds.id,
        login: creds.login,
        sigfox_group: creds.sigfox_group,
        default_contract_id: creds.default_contract_id,
      };
      this.toggleForm = true;
      this.showForm = true;
    } else {
      this.hasPassword = false;
      this.toggleForm = false;
    }
  }

  private toggle() {
    if (!this.toggleForm) {
      this.dialog = true;
      this.showForm = true;

    } else {
      this.dialog = false;
      this.showForm = true;

    }
  }

  private async saveCredentials() {
    this.activateRules();

    await this.$nextTick();

    if (this.$refs.form && ((this.$refs.form as Vue & { validate: () => boolean }).validate())) {
      if (this.toggleForm) {
        let credentials = {};
        if (this.newPassword.length > 0) {
          credentials = {...this.credentials, password: this.newPassword};
        } else {
          credentials = {...this.credentials};
        }

        this.credentials.id
          ? await ConnectivityService.updateSigfoxApiCredentials(String(this.credentials.id), credentials as SigfoxApiCredentials)
          : await ConnectivityService.createSigfoxApiCredentials(credentials as SigfoxApiCredentials);

        this.snackbar = true;
        this.requiredRules = {};

      }
    }
  }

  private async removeCredentials() {
    if (this.credentials.id) {
      await ConnectivityService.deleteSigfoxApiCredentials(this.credentials.id.toString());
    }
    this.dialog = false;
    this.toggleForm = false;
    this.showForm = false;
    this.snackbar = true;
    this.credentials = {} as SigfoxApiCredentials;
  }

  private activateRules() {
    this.requiredRules = {
      login: [
        (v: string) => !!v || `Login can't be empty`,
        (v: string) => v && v.length >= 0 || `Login can't be empty`,
      ],
      password: [
        (v: string) => (this.hasPassword || (!this.hasPassword && this.newPassword.length > 0)) || `Password can't be empty1`,
      ],
    };
  }
}
